import {
    mobileHeightThreshold,
    mobileThreshold
} from '@he-novation/design-system/constants/constants.style';

const isSmallScreen = (width, height) =>
    width <= mobileThreshold || height <= mobileHeightThreshold;

export default isSmallScreen;
